import Platform from '@/types/Platform'

export default Platform.fromStorable({
	id: 'ebay',
	settings: {
		logo: require('@/assets/logo-ebay.png'),
		name: 'ebay',
		format: {
			width: 2500,
			height: 2500
		},
		maxCount: 20,
		defaultOverlays: [{ name: 'WatermarkAnnotation', args: [true] }],
		setRules: {
			'0': [
				{
					category: ['special', 'title'],
					allowFullPicture: true,
					padding: {
						top: 0.2,
						bottom: 0.2
					},
					overlays: [
						{ name: 'WatermarkAnnotation' },
						{ name: 'BrandLogoAnnotation' }
					]
				}
			]
		},
		rules: {
			'0': [
				{
					category: ['special', 'title'],
					allowFullPicture: true,
					padding: {
						top: 0.2,
						bottom: 0.2
					},
					overlays: [
						{ name: 'WatermarkAnnotation' },
						{ name: 'BrandLogoAnnotation' }
					]
				}
			],
			'1': [
				{
					category: ['special', 'measurements'],
					allowFullPicture: true,
					padding: {
						top: 0.24,
						bottom: 0.31
					},
					overlays: [
						{ name: 'BrandLogoAnnotation' },
						{ name: 'MeasurementAnnotation', args: [true] }
					]
				}
			],
			'2': [
				{
					category: ['functions', null],
					allowFullPicture: true,
					allowFindNext: true,
					padding: {
						top: 0.2,
						bottom: 0.2
					},
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			'3': [
				{
					category: ['functions', null],
					allowFullPicture: true,
					allowFindNext: true,
					padding: {
						top: 0.2,
						bottom: 0.2
					},
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			'4': [
				{
					category: ['functions', null],
					allowFullPicture: true,
					allowFindNext: true,
					padding: {
						top: 0.2,
						bottom: 0.2
					},
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			'5': [
				{
					category: ['functions', null],
					allowFullPicture: true,
					allowFindNext: true,
					padding: {
						top: 0.2,
						bottom: 0.2
					},
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			'6': [
				{
					category: ['special', 'materialDetail'],
					allowFullPicture: true,
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			'7': [
				{
					category: ['detail', null],
					allowFullPicture: true,
					allowFindNext: true
				}
			],
			'8': [
				{
					category: ['detail', null],
					allowFullPicture: true,
					allowFindNext: true
				}
			],
			'9': [
				{
					category: ['detail', null],
					allowFullPicture: true,
					allowFindNext: true
				}
			],
			'10': [
				{
					category: ['detail', 'damages'],
					allowFullPicture: true,
					allowFindNext: true,
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			'11': [
				{
					category: ['detail', 'damages'],
					allowFullPicture: true,
					allowFindNext: true,
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			'12': [
				{
					category: ['detail', 'damages'],
					allowFullPicture: true,
					allowFindNext: true,
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			'13': [
				{
					category: ['special', 'colors'],
					allowFullPicture: true,
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			],
			'14': [
				{
					category: ['special', 'logo'],
					allowFullPicture: true,
					overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
				}
			]
		},
		fillRule: [
			{
				category: ['alternate', null],
				allowFullPicture: true,
				padding: {
					top: 0.2,
					bottom: 0.2
				},
				overlays: [{ name: 'WatermarkAnnotation', args: [true] }]
			}
		]
	}
})
